<template>
  <q-layout view="hHh lpR fFf" class="bg-black column justify-center">
    <WelcomeInput/>
  </q-layout>
</template>

<script>
import WelcomeInput from '~/views/WelcomeInput.vue';

export default {
  name: "Visu",
  components: {
    WelcomeInput
  }
}
</script>